// These are just hard-coded on our end, and they don't come from Stripe.
export const standardIncludedUsers = 1;
export const standardIncludedSourcesCount = 1;
export const growthIncludedUsers = 1;
export const growthIncludedSourcesCount = 1;
